export function getTime(date: string | undefined) {
	if (!date) return 0
	return new Date(date).getTime()
}

import { watch } from 'vue'

/**
 * Persists a reactive store variable to localStorage, restoring on load and updating when it changes.
 * 
 * @param key The localStorage key to use.
 * @param storeVar A ref or reactive variable to persist.
 * @param options Optional: { deep: boolean } for deep objects.
 */
export function persist(key: string, storeVar: any, initialValue: any, options?: { deep?: boolean }) {
	// Try to restore from localStorage (parse & fallback handling)
	let restored: any = initialValue
	const ls = localStorage.getItem(key)
	if (ls !== null) {
		try {
			restored = JSON.parse(ls)
		} catch {
			// If parse fails, treat as plain (primitive) value
			restored = ls
		}
	}

	watch(
		storeVar,
		(newVal) => {
			try {
				// Store objects/arrays as JSON, otherwise as plain string
				let toStore
				if (typeof newVal === 'object' && newVal !== null) {
					toStore = JSON.stringify(newVal)
				} else {
					toStore = String(newVal)
				}
				localStorage.setItem(key, toStore)
			} catch (e) {
				console.error(`Failed to store value for key "${key}":`, e)
			}
		},
		{ deep: options?.deep ?? true }
	)
	return restored
}
